<template>
  <!-- Loading state -->
  <div v-if="loading" class="text-center py-12">
    <p class="mt-4 text-gray-600">Loading Dashboard data...</p>
    <MainLoader />
  </div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" v-else>
    <Cards :metrics="metrics" />
    <Charts :metrics="metrics" />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import MainLoader from "@/components/MainLoader.vue";
import Cards from "@/components/rfi-dashboard/RFIDCardsMetrics.vue";
import Charts from "@/components/rfi-dashboard/RFIDCharts.vue";
import { calculateAllMetrics } from "@/helpers/metrics";

export default {
  components: {
    MainLoader,
    Cards,
    Charts,
  },

  setup() {
    const store = useStore();
    // const currentUser = store.state.users.user;
    const allRfis = ref([]);
    const rfisRequested = ref([]);
    const rfisDirected = ref([]);
    const loading = ref(true);
    const error = ref(null);
    const metrics = ref({});

    const fetchRfis = async () => {
      try {
        loading.value = true;
        const response = await store.dispatch("fetchRFIs");

        if (!response.ok) {
          throw new Error("Failed to fetch RFIs");
        }

        const data = response.data;

        if (data.allData) {
          allRfis.value = data.allData;
        } else {
          rfisRequested.value = data.requestorMatches || [];
          rfisDirected.value = data.directedToMatches || [];
        }

        metrics.value = calculateAllMetrics(
          rfisRequested.value,
          rfisDirected.value,
          allRfis.value
        );
        console.log("🚀 ~ fetchRfis ~ metrics:", metrics.value);
      } catch (err) {
        error.value = err.message;
        console.error("Error fetching RFIs:", err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(fetchRfis);

    return {
      fetchRfis,
      allRfis,
      rfisRequested,
      rfisDirected,
      loading,
      metrics,
    };
  },
};
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>